<template>
    <div class="row">
        <div class="col-12 col-md-12">
            <div class="card">
                <div class="card-header">
                    {{t('History of email communication')}}
                </div>
                <div class="card-body p-0">
                    <data-grid ref="dataGrid"
                               :settings="grid"
                               :page="page"
                               :storeDispatchList="loadData"
                               :hidePaginator="hidePaginator"
                    >
<!--                        <template slot="attachment" slot-scope="data">-->
<!--                            <div @click="openModal($id)">-->
<!--                                {{data.item.attachment}}-->
<!--                            </div>-->
<!--                        </template>-->
                        <template slot="subject" slot-scope="data">
                            {{data.item.subject}}
                            <div class="attachments">
                                <div class="badge badge-secondary" v-for="attachment in data.item.mailAttachment">
                                    <a :href="attachment.downloadLink"
                                       target="_blank"
                                       class="link"
                                    >
                                        {{attachment.name}}
                                    </a>
                                </div>
                            </div>
                        </template>
                        <template slot="time" slot-scope="data">
                            {{data.item.time | dateTime}}
                        </template>
                    </data-grid>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Loading from '../core/Components/loading';
    import DataGrid from '../core/DataGrid/DataGrid';
    import TheHeader from '../admin/Layout/TheHeader';
    import {apiLink} from '../store/api';


    export default {
        components: {
            Loading,
            DataGrid,
            TheHeader
        },
        props: {
            applicationId: {
                type: Number,
                required: true,
            },
            hidePaginator: {
                type: Boolean,
                default: true,
            },
            sortable: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            this.initGridColumns();
        },
        methods: {
            reloadData() {
                this.$refs.dataGrid.fetchData();
            },
            loadData() {
                this.loading = true;
                return this.$store.dispatch('mails/list', {
                    page: this.page,
                    perPage: 10,
                    id: this.applicationId,
                })
            },
            initGridColumns() {
                this.grid.columns = this.grid.columns.concat([
                    {
                        type: 'string',
                        name: this.t('Order number'),
                        key: 'id',
                        sortable: this.sortable,
                    }, {
                        type: 'string',
                        name: this.t('Subject'),
                        key: 'subject',
                        sortable: this.sortable,
                    }, {
                    //     type: 'number',
                    //     name: this.t('Count attachment'),
                    //     key: 'attachment',
                    //     sortable: this.sortable,
                    // }, {
                        type: 'date',
                        name: this.t('Date'),
                        key: 'time',
                        sortable: this.sortable,
                    }
                ]);
            }
        },
        data() {
            return {
                loading: true,
                page: 1,
                paginator: {},
                mails: [],
                openedModal: false,
                openedMail: null,
                pdf: null,
                link: '/api/mail/show-mail/',
                grid: {
                    buttons: [
                        {
                            type: 'link',
                            target: '_blank',
                            to: (item) => {
                                return apiLink() + 'mail/show-mail/' + item.id;
                            },
                            name: this.t('Show'),
                            icon: 'pencil-alt',
                            styleClass: 'btn-primary btn-sm'
                        }
                    ],
                    columns: []
                },
            };
        }
    }
</script>
<style lang="scss">
    .table {
        /*border: 1px solid #eff1f4;*/
        margin-bottom: 0;
    }

    .titan-grid {
        .attachments {
            a {
                color: white;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/mail-list.vue